<template>
  <div class="login-header">
    <div class="gradation"></div>
    <div class="header-top">
      <div>
        <img class="top-logo" src="@/assets/images/common/bayer_logo_white.png" alt="app_logo" />
      </div>
      <div>
        <v-btn icon depressed dark @click="$emit('clickHome')">
          <v-icon dark>mdi-home-outline</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="sub-title">
      <img src="@/assets/images/common/pharm_partner_welcome_logo_white.png" alt="pharm_partner_welcome_logo_white" />

      <p>귀한 농사 여정에 바이엘이 함께 합니다.</p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss">
.login-header {
  position: relative;
  padding: 1.5rem 1rem 2.5rem;
  text-align: center;
  background: url(~@/assets/images/common/login_header_bg.jpeg);
  background-size: cover;
  color: #ffffff;
  border-radius: 0 0 30px 30px;
  height: 300px;
  overflow: hidden;

  .gradation {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(#00420a, rgba(0, 0, 0, 0.5));
    opacity: 0.8;
  }

  .header-top {
    position: relative;
    text-align: left;
    padding: 0 0 10px;

    >div {
      width: 50%;
      display: inline-block;
      vertical-align: middle;

      &:last-child {
        text-align: right;
      }
    }

    .top-logo {
      width: 40px;
    }

    .v-btn {
      background: rgba(0, 0, 0, 0.5);
      border-radius: 50%;
    }
  }

  .sub-title {
    position: relative;

    img {
      width: 200px;
    }

    p {
      margin-top: 10px;
    }
  }

  .input-guide {
    margin-top: 1.5rem;
    // color: $primary-color;
  }
}
</style>